import React, { useMemo, useContext } from 'react';
import classNames from 'classnames';
import { Button } from 'ncoded-component-library';
import { useTranslation } from 'react-i18next';
import {
  BUYER_SIDE_FILTERS,
  FilterCopies,
  FILTER_COPIES_TO_COUNT_MAP,
  SELLER_SIDE_FILTERS,
  IN_REVIEW_QUERY_BUY_SIDE,
} from './data';
import { isQASellAnswerApprover } from '../../utils';
import QAndAContext from '../../providers/QAndA/QAndA.context';
import useQueryFilter from 'hooks/useQueryFilter';
import DataRoomContext from '../../providers/DataRoom/DataRoom.context';
import { isUndefined } from 'utils';
import MembersContext from '../../providers/Members/Members.context';

import './QAndARoleFilter.styles.scss';

type QAndARoleFilterProps = {
  className?: string;
};

const QAndARoleFilter: React.FC<QAndARoleFilterProps> = (props) => {
  const { className } = props;

  const { qaRole, isBuySide } = useContext(DataRoomContext);
  const { filterCount } = useContext(QAndAContext);
  const { buySideGroups } = useContext(MembersContext);

  const doesNotHaveInReviewTab = useMemo(
    () =>
      isBuySide &&
      buySideGroups?.[0]?.autoApproveQuestions &&
      !filterCount?.inReviewCount,
    [buySideGroups, filterCount, isBuySide],
  );

  const classes = classNames('q-and-a-role-filter', className);

  const { t } = useTranslation();
  const {
    params: { $or = '' },
    onFiltersApply,
  } = useQueryFilter();

  const filters = useMemo(() => {
    if (isBuySide) {
      return !doesNotHaveInReviewTab
        ? BUYER_SIDE_FILTERS
        : BUYER_SIDE_FILTERS.filter(
            ({ value }) => value !== IN_REVIEW_QUERY_BUY_SIDE,
          );
    }

    return SELLER_SIDE_FILTERS.filter(
      ({ fval }) =>
        !(isQASellAnswerApprover(qaRole) && fval === FilterCopies.UNANSWERED),
    );
  }, [isBuySide, doesNotHaveInReviewTab, qaRole]);

  const Content = useMemo(
    () =>
      filters.map(({ label, value, fval }) => (
        <Button
          key={label}
          className={$or === value && !!filterCount ? 'selected' : ''}
          onClick={() => onFiltersApply('$or', value)}
        >
          {t(label)}
          {!isUndefined(filterCount?.[FILTER_COPIES_TO_COUNT_MAP[fval]]) && (
            <span>{filterCount?.[FILTER_COPIES_TO_COUNT_MAP[fval]]}</span>
          )}
        </Button>
      )),
    [$or, filterCount, filters, onFiltersApply, t],
  );

  return <div className={classes}>{Content} </div>;
};

export default QAndARoleFilter;
